import { render, staticRenderFns } from "./UpdateResult.vue?vue&type=template&id=2f58126b&"
import script from "./UpdateResult.vue?vue&type=script&lang=js&"
export * from "./UpdateResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports